import React from 'react';
import { Trophy, Smartphone, Zap, Target, ShieldCheck, CheckCircle2, Star } from 'lucide-react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export const Hero = () => {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-10 md:pt-24 md:pb-24 overflow-hidden" data-id="element-151">
      {/* Background Elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-gold-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-152" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-153">
        <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-154">
          {/* Eyebrow */}
          <FadeIn data-id="element-155">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-navy-800 border border-navy-700 mb-4 md:mb-6" data-id="element-156">
              <Trophy className="w-4 h-4 text-gold-500" data-id="element-157" />
              <span className="text-xs md:text-sm font-medium text-gray-300 uppercase tracking-wider" data-id="element-158">
                Sistema N°1 para Armadores de Voleibol en Argentina
              </span>
            </div>
          </FadeIn>

          {/* Title + Subtitle */}
          <FadeIn delay={0.1} data-id="element-159">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bebas text-white leading-[0.9] mb-3 md:mb-4 text-glow-gold" data-id="element-160">
              ARMADOR DE <span className="text-gold-500" data-id="element-161">ÉLITE™</span>
            </h1>
            <p className="text-xl md:text-3xl font-bebas text-gray-300 mb-6 md:mb-8 tracking-wide" data-id="element-162">
              El Megapack del Armador Completo
            </p>
          </FadeIn>

          {/* Mockup Image - now centered, below title/subtitle */}
          <FadeIn delay={0.2} className="w-full" data-id="element-163">
            <div className="relative max-w-[70%] sm:max-w-md md:max-w-lg mx-auto mb-8 md:mb-10" data-id="element-164">
              {/* Decorative glow behind mockup */}
              <div className="absolute inset-0 bg-gradient-radial from-gold-500/20 via-transparent to-transparent blur-2xl scale-110 pointer-events-none" data-id="element-165" />
              <div className="relative z-10" data-id="element-166">
                <img src="https://cdn.magicpatterns.com/uploads/fdZgMFLsLWnDBei2xvzbdP/MOCKUPARMADOR-Photoroom.png" alt="Armador de Élite Megapack" className="w-full h-auto object-contain drop-shadow-[0_25px_50px_rgba(212,175,55,0.25)]" data-id="element-167" />
              </div>

              {/* Trust badge floating */}
              <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 md:-bottom-4 md:left-auto md:right-0 md:translate-x-0 bg-navy-800 border border-navy-700 px-3 py-2 md:p-4 rounded-xl shadow-xl flex items-center gap-2 md:gap-3 z-20" data-id="element-168">
                <div className="flex -space-x-2" data-id="element-169">
                  {[1, 2, 3, 4].map(i => <div key={i} className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-navy-600 border-2 border-navy-800 flex items-center justify-center" data-id="element-170">
                      <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4 text-gold-500" data-id="element-171" />
                    </div>)}
                </div>
                <div className="text-left" data-id="element-172">
                  <div className="text-xs md:text-sm font-bold text-white flex items-center gap-1" data-id="element-173">
                    +200 armadores{' '}
                    <Star className="w-3 h-3 fill-gold-500 text-gold-500" data-id="element-174" />
                  </div>
                  <div className="text-[10px] md:text-xs text-gray-400" data-id="element-175">
                    confían en el sistema
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>

          {/* Description */}
          <FadeIn delay={0.3} data-id="element-176">
            <p className="text-base md:text-xl text-gray-400 mb-6 md:mb-8 max-w-2xl leading-relaxed" data-id="element-177">
              Todo tu desarrollo como armador resuelto. Técnica, táctica,
              distribución inteligente, liderazgo, preparación física y
              mentalidad.{' '}
              <strong className="text-white font-medium" data-id="element-178">
                Sin improvisar nunca más en la cancha.
              </strong>
            </p>
          </FadeIn>

          {/* Value props */}
          <FadeIn delay={0.35} className="w-full" data-id="element-179">
            <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-6 md:mb-8 text-sm text-gray-300" data-id="element-180">
              <div className="flex items-center gap-1.5" data-id="element-181">
                <Smartphone className="w-4 h-4 text-gold-500" data-id="element-182" /> PDF digital
              </div>
              <div className="flex items-center gap-1.5" data-id="element-183">
                <Zap className="w-4 h-4 text-gold-500" data-id="element-184" /> Acceso inmediato
              </div>
              <div className="flex items-center gap-1.5" data-id="element-185">
                <Target className="w-4 h-4 text-gold-500" data-id="element-186" /> Todos los niveles
              </div>
              <div className="flex items-center gap-1.5" data-id="element-187">
                <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-188" /> Garantía 7
                días
              </div>
            </div>
          </FadeIn>

          {/* CTA */}
          <FadeIn delay={0.4} className="w-full max-w-xl" data-id="element-189">
            <Button size="lg" fullWidth className="mb-6 group" onClick={scrollToPricing} data-id="element-190">
              <span className="mr-2 group-hover:scale-110 transition-transform" data-id="element-191">
                💥
              </span>
              QUIERO MI ARMADOR DE ÉLITE
            </Button>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-sm text-gray-400" data-id="element-192">
              <div className="flex items-center gap-2" data-id="element-193">
                <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-194" /> Pago 100%
                seguro
              </div>
              <div className="hidden sm:block w-1 h-1 rounded-full bg-gray-600" data-id="element-195" />
              <div data-id="element-196">Mercado Pago | Tarjeta | Transferencia</div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
};